module.exports = __webpack_public_path__ + "img/chicken-salad.15d9b0f3.jpg";